

indexController = (ChangeLogService, changes, program) ->
    'ngInject'
    vm = @

    @program = program
    @changes = changes
    @hasMore = changes.length > 0

    @loadMore = ->
        lastId = vm.changes[changes.length - 1].id
        return ChangeLogService.index(after: lastId, count: 1)
           .then (moreChanges) ->
                vm.hasMore = moreChanges.length > 0
                vm.changes.push(moreChanges...)
                return 

    return 


indexListView =
    templateUrl: 'changeLog/list'
    controller: indexController
    controllerAs: 'ctrl'
    resolve: changes: (ChangeLogService, Principal) ->
        'ngInject'
        Principal.new_announcements = false
        return ChangeLogService.index(count: 3)

indexHeaderView = 
    template: '<a if-permission="createChangeLog" class="button" ui-sref="^.new">New Post</a>'


menuView = 
    templateUrl: 'programs/menu'
    controller: 'ProgramBaseController'

getPrincipalProgram =(Principal, ModelService) ->
    'ngInject'

    if Principal.program_count == 1
        return ModelService.getRelation('program', Principal.program_slug, 'summary')
    else
        return null

getProgramPermissions = (program, ModelService) ->
    'ngInject'

    if program?
        return ModelService.getModelRelation(program, 'permissions')
    else return {}

getProgramIssues = (program, IssueService) ->
    'ngInject'
    if program?
        return IssueService.loadIssues('program', program.id)
    return {}

stateConfig = ($stateProvider) ->
    'ngInject'

    $stateProvider.state 'changeLog',
        abstract: true
        parent: 'basic'
        url: '/announcements'
        resolve:
            program: getPrincipalProgram
            permissions: getProgramPermissions
            issues: getProgramIssues
        views:
            '': templateUrl: 'changeLog/base'
            'contextNav@basic': menuView


    $stateProvider.state 'changeLog.list',
        url: ''
        views:
            'header': indexHeaderView
            '@changeLog': indexListView

module.config stateConfig